import req from "../../../services/psikotest/request";

class EppsQuestionary {
  async list() {
    try {
      const res = await req.get("/api/psikotest_system/epps_questionary/");
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  async create(data: TPSEppsQuestionary) {
    try {
      const res = await req.post("/api/psikotest_system/epps_questionary/", data);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  async update(id: number, data: TPSEppsQuestionary) {
    try {
      const res = await req.put("/api/psikotest_system/epps_questionary/" + id, data);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  async delete(id: number) {
    try {
      const res = await req.delete("/api/psikotest_system/epps_questionary/" + id);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
}

export default EppsQuestionary;
